import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';

import { fromEvent ,  BehaviorSubject ,  EMPTY as empty ,  Subscription } from 'rxjs';
import { tap ,  catchError ,  debounceTime ,  retry ,  switchMap } from 'rxjs/operators';

import { GaService } from 'app/core/services/ga/ga.service';
import { TenantService } from 'app/core/services/tenant/tenant.service';

import { FavoriteService } from '../../services/favorite.service';
import { AuthService } from '../../../core/services/auth/auth.service';
import { RouterLink } from '@angular/router';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-favorite-button',
    templateUrl: './favorite-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterLink, NgTemplateOutlet, AsyncPipe]
})
export class FavoriteButtonComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() id: number;
  @Input() favorited = false;

  constructor(
    public authService: AuthService,
    public tenantService: TenantService,
    private favoriteService: FavoriteService,
    private element: ElementRef,
    @Optional() private gaService: GaService
  ) {}

  @HostBinding('class') class = 'button';

  api$: Subscription;
  favorite$: BehaviorSubject<boolean>;

  ngOnInit() {
    this.favorite$ = new BehaviorSubject(this.favorited);

    this.api$ = fromEvent(this.element.nativeElement, 'click')
      .pipe(
        tap(() => this.favorite$.next(!this.favorite$.getValue())),
        debounceTime(250),
        switchMap(() =>
          this.favoriteService.updateFavorite(this.type, this.id, this.favorite$.getValue()).pipe(
            tap(() => {
              if (this.gaService) {
                this.gaService.gaSendEvent([
                  this.tenantService.newspaperName,
                  'Clic',
                  this.favorite$.getValue() ? 'Ajout​ ​aux​ ​favoris​ ​d’un article' : 'Supprimer des Favoris'
                ]);
              }
            }),
            retry(2)
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.api$.unsubscribe();
  }
}
